<template>
    <v-layout row wrap class="mt-2">
        <v-flex xs12 sm12 md12 mt-2>
            <v-card class="mx-auto mr-3 ml-3" width="100%">
                <v-card-title class="justify-center primary">
                    <v-toolbar-title id="titulocard">Tipo Llamada</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon :color="'#FFFFFF'">mdi-phone</v-icon>
                </v-card-title>
                <v-card-text>
                    <div class="text-center">
                        <v-btn-toggle v-model="tipoLlamada"
                                      mandatory
                                      class="d-flex justify-center">
                            <v-btn value="1"
                                   :color="tipoLlamada === '1' ? 'blue darken-2' : 'white'"
                                   class="ma-2 px-6 py-5"
                                   x-large
                                   @click="cambiarTipo('1')"
                                   elevation="3"
                                   :class="tipoLlamada === '1' ? 'white--text' : 'black--text'">
                                <v-icon left :color="tipoLlamada === '1' ? 'white' : 'black'">mdi-phone</v-icon>
                                Llamada por Línea Telefónica
                            </v-btn>

                            <v-btn value="2"
                                   :color="tipoLlamada === '2' ? 'blue darken-2' : 'white'"
                                   class="ma-2 px-6 py-5"
                                   x-large
                                   @click="cambiarTipo('2')"
                                   elevation="3"
                                   :class="tipoLlamada === '2' ? 'white--text' : 'black--text'">
                                <v-icon left :color="tipoLlamada === '2' ? 'white' : 'black'">mdi-apps</v-icon>
                                Llamada por Softphone
                            </v-btn>
                        </v-btn-toggle>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                    <div mt-2 style="text-align: center;">
                        <v-btn class="mr-4 mt-3" color="secondary" @click="Cancelar">Cancelar</v-btn>
                    </div>
                </v-card-actions>


            </v-card>
        </v-flex>
        
    </v-layout>
</template>


<script>
import { mapActions, mapState } from 'vuex'
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import PerfilServ from '@/services/main/perfil.service.js';


    export default {
        props: {
            ustipollamada: 0,
        },
        data: () => ({
            tipoLlamada: null
        }),
        watch: {

        },
        computed: {
            ...mapState({ drawer: state => state.drawer }),
            ...mapState(['domain', 'informationPage']),
            DRAWER_STATE: {
                get() {
                    return this.drawer
                },
            },

        },
        methods: {
            ...mapActions(['TOGGLE_DRAWER']),
            cambiarTipo(x) {
                if (x != this.tipoLlamada){
                    this.$swal({
                        position: 'center',
                        icon: 'warning',
                        title: '¿Está seguro de cambiar el tipo de llamada?',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Aceptar',
                        cancelButtonText: 'Cancelar',
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            this.guardar();
                        }
                        else {
                            if (x == "1") {
                                this.tipoLlamada = "2";
                            } else {
                                this.tipoLlamada = "1";
                            }

                        }
                    });
                }
                
            },
            async guardar() {
                this.$swal({
                    position: 'center',
                    title: 'Cambiando tipo de llamada, espere un momento por favor...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });
                
                setTimeout(async () => {
                    await PerfilServ.ModificarTipoLlamada(this.tipoLlamada);
                  
                    this.$swal({
                        position: 'center',
                        icon: 'success',
                        title: 'Éxito',
                        text: 'Se cambió el tipo de llamada con éxito.',
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.$emit('BtnCancelar')
                        }
                    })

                }, 800);
               

            },
            Cancelar() {
                this.$emit('BtnCancelar')
            }
        },
        async mounted() {
            this.tipoLlamada = this.ustipollamada;
           
            
        },
    }
</script>
<style>
    .lista .vs-list--subtitle {
        font-size: 16px !important;
    }
</style>